/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Which step of the frontend pre-auth wizard a `review`-status submission
 * is on. Null (unset) for submissions from before this field existed, or
 * for facilities without the carve-outs step enabled — both cases should
 * be treated as `review` by consumers.
 * 
 * @export
 */
export const PalAuthWizardStage = {
    CarveOuts: 'carve_outs',
    CoverSheet: 'cover_sheet',
    Review: 'review',
} as const;
export type PalAuthWizardStage = typeof PalAuthWizardStage[keyof typeof PalAuthWizardStage];


export function instanceOfPalAuthWizardStage(value: any): boolean {
    for (const key in PalAuthWizardStage) {
        if (Object.prototype.hasOwnProperty.call(PalAuthWizardStage, key)) {
            if (PalAuthWizardStage[key as keyof typeof PalAuthWizardStage] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PalAuthWizardStageFromJSON(json: any): PalAuthWizardStage {
    return PalAuthWizardStageFromJSONTyped(json, false);
}

export function PalAuthWizardStageFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthWizardStage {
    return json as PalAuthWizardStage;
}

export function PalAuthWizardStageToJSON(value?: PalAuthWizardStage | null): any {
    return value as any;
}

export function PalAuthWizardStageToJSONTyped(value: any, ignoreDiscriminator: boolean): PalAuthWizardStage {
    return value as PalAuthWizardStage;
}

